export function AppLoadingFallback() {
  return (
    <div
      aria-live="polite"
      className="flex min-h-dvh w-full items-center justify-center bg-[var(--app-bg)] text-[var(--app-text-primary)]"
      role="status"
    >
      <span className="text-[17px] font-bold">
        Загружаем
        <span
          aria-hidden="true"
          className="inline-block"
        >
          …
        </span>
      </span>
    </div>
  );
}
